"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.1s linear;\n  color: white;\n  cursor: pointer;\n  margin-left: ", ";\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlContainer = void 0;

var react_1 = __importDefault(require("react"));

var ClickableContainer_1 = require("../dom/ClickableContainer");

var isNative_1 = require("../isNative");

var styled_1 = require("../styled");

var theme_1 = require("../theme");

function ControlContainer(_ref) {
  var children = _ref.children,
      compact = _ref.compact,
      onClick = _ref.onClick,
      style = _ref.style,
      padded = _ref.padded;
  var theme = (0, theme_1.useTheme)();
  var iconSize = compact ? (0, theme_1.sizeToNumber)((0, theme_1.getSize)(theme, '@size-s')) : (0, theme_1.sizeToNumber)((0, theme_1.getSize)(theme, '@size-s')) + (0, theme_1.sizeToNumber)((0, theme_1.getSize)(theme, '@size-xxs'));
  return react_1.default.createElement(_ControlContainer, {
    compact: compact,
    padded: padded,
    onClick: onClick,
    style: style
  }, react_1.default.cloneElement(children, {
    color: 'white',
    width: iconSize,
    height: iconSize,
    display: isNative_1.isNative ? undefined : 'block'
  }));
}

exports.ControlContainer = ControlContainer;

var _ControlContainer = (0, styled_1.styled)(ClickableContainer_1.ClickableContainer)(_templateObject(), isNative_1.isNative ? 1 : 0.75, function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact ? '@size-xxs' : '@size-s');
}, function (props) {
  return props.padded ? "0px ".concat((0, theme_1.getSize)(props.theme, props.compact ? '@size-xxs' : '@size-s'), "px") : null;
});